module.exports = "https://web-assets.ifttt.com/packs/media/examples/Nasa-android-applet@3x-cdeb3506.png";